export default __webpack_public_path__ + "static/media/call-icon.08cdc1ec.svg";